import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'
import {
  RequestTypes,
  registerItemKeys,
} from '@core/react-query/features/registers/registers/register/items/item'
import { RequestErrorType } from '@core/utils/api-axios-instance'
import { registerItemsKeys } from '@core/react-query/features/registers/registers/register/items'
import { IRegisterItem } from '@core/entities/register/RegisterItem'

export const useArchiveRegisterItem = (
  options?: UseMutationOptions<
    IRegisterItem,
    RequestErrorType,
    RequestTypes['archiveRegisterItem']
  >,
) => {
  const queryClient = useQueryClient()

  return useMutation({
    ...registerItemKeys.archiveRegisterItem,
    ...options,
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries(registerItemsKeys.itemsByRegisterId._def)
      queryClient.invalidateQueries(registerItemKeys.byId({ ...variables }))
    },
  })
}
